export default "__VITE_ASSET__wUGFOlhP__"